import React, { useContext } from "react";
import { useHistory } from "react-router-dom";

import "./empty-cart-style.scss";
import { DeviceContext, deviceType } from '@providers';

import Button from "@src/componentsNew/Buttons/Button";
import Typography from "@src/componentsNew/Typography/Typography";
import ArrowForwardIcon from "@src/componentsNew/Icons/Icons/ArrowForwardIcon";

import { baseUrl } from "@src/app/routes";

const EmptyCart = () => {
  const history = useHistory();
  const { isMobile } = useContext<deviceType>(DeviceContext);

  return (
    isMobile ? (
      <div className="mobile-empty-cart-container">
        <div className="empty-cart-text-wrapper">
          <Typography variant="subtitle1" component="h4" style={{ color: "#212121" }}>
            Your Shopping Bag is Empty!
          </Typography>

          <div className="normal-text-wrapper">
            <Typography variant="body3" component="p" style={{ color: "#666666" }}>
              Add your favorite K-beauty products
            </Typography>
            <Typography variant="body3" component="p" style={{ color: "#666666" }}>
              and start your journey to true beauty.
            </Typography>
          </div>
        </div>

        <div className="start-shopping-button-wrapper">
          <Button
            cName="start-shopping-button"
            variant="contained"
            size="large"
            endIcon={<ArrowForwardIcon fillColor="#FFFFFF" />}
            onClick={() => history.push(baseUrl)}>
            Start Shopping
          </Button>
        </div>
      </div>
    ) : (
      <div className="desktop-empty-cart-container">
        <div className="empty-cart-text-wrapper">
          <Typography variant="h6" component="h4" style={{ color: "#212121" }}>
            Your Shopping Bag is Empty!
          </Typography>

          <Typography variant="body1" component="p" style={{ color: "#666666" }}>
            Add your favorite K-beauty products and start your journey to true beauty.
          </Typography>
        </div>

        <Button
          cName="start-shopping-button"
          variant="contained"
          size="large"
          endIcon={<ArrowForwardIcon fillColor="#FFFFFF" />}
          onClick={() => history.push(baseUrl)}>
          Start Shopping
        </Button>
      </div>
    )
  )
};

export default EmptyCart;
